/**
 * Breadcrumbs Component - Navigation breadcrumb trail with proper links
 */

import React from 'react'
import { ChevronRight, Home } from 'lucide-react'

const Breadcrumbs = ({
  items = [],
  className = '',
  separator = <ChevronRight size={14} className="text-neutral-400" />,
  homeIcon = <Home size={14} className="text-neutral-400" />,
  onNavigate,
  ...props
}) => {
  if (!items || items.length === 0) return null

  return (
    <nav
      className={`flex items-center gap-1.5 text-sm ${className}`}
      aria-label="Breadcrumb"
      {...props}
    >
      {/* Home */}
      <button
        onClick={() => onNavigate?.('dashboard')}
        className="text-neutral-400 hover:text-brand transition-colors p-1"
        aria-label="Home"
      >
        {homeIcon}
      </button>

      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <React.Fragment key={index}>
            <span className="text-neutral-300">{separator}</span>
            {isLast ? (
              // ✅ Current page - not clickable
              <span className="font-semibold text-ink">{item.label}</span>
            ) : (
              // ✅ Clickable breadcrumb - navigates to that page
              <button
                onClick={() => onNavigate?.(item.route)}
                className="text-muted hover:text-brand transition-colors hover:underline underline-offset-2"
              >
                {item.label}
              </button>
            )}
          </React.Fragment>
        )
      })}
    </nav>
  )
}

Breadcrumbs.displayName = 'Breadcrumbs'

export default Breadcrumbs